/**
 * File: subjectStudentListing.js
 * Project: educore
 * Created Date: 2019-02-18
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class SubjectStudentController {
    // @ngInject
    constructor($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        let academicDet = localStorageService.get("authoringData");
        let academics = {
            school_id: academicDet.school_id,
            batch_id: academicDet.batch_id,
            curriculum_id: academicDet.curriculum_id,
            subject_id: academicDet.subject_id,
            session_id: academicDet.session_id,
            class_id: academicDet.class_id,
            academic_year: academicDet.academic_year
        }

        /*
         * Function to get assigned users
         * 
         */
        authService.callAPI(TPWIZARDCONSTANT.API_GET_STUDENTS, "POST", academics, function(response) {
            if (response.result && response.result.data && response.result.data.data.length > 0) {
                try {
                    $scope.isLoading = false

                    $scope.studentList = response.result.data.data;
                    //To sort student list
                    $scope.studentList.sort(function(a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    });
                } catch (ex) {
                    console.log(ex);
                }
                _.defer(function() {
                    $scope.$apply();
                });
            } else {
                toastr.error('Network Error. Please try later');
            }
        });
        /*
         * Function to go to single student based report
         * 
         * @id : String - Id of the question paper
         * 
         * @return : null
         *
         */
        $scope.gotoStudentSubjectReport = (id) => {
            $state.go("subjectReport", {
                studentId: id
            })
        }

    }
}

export default SubjectStudentController;



// WEBPACK FOOTER //
// ./src/app/authoring-tool/controllers/subjectStudentListing.js